import { TablePerfilAcesso } from "./Components/Table/TablePerfilAcesso";

export const PagePerfisDeAcesso = () => {
  return <TablePerfilAcesso />;
};
